<div [ngClass]="containerCss" class="attachment-item-container display-flex flex-column">
  <ng-container
    *ngIf="attachmentItem?.fileUploadId || newAttachmentItem?.upload"
    [ngTemplateOutlet]="fileTemplate"
  ></ng-container>
  <ng-container
    *ngIf="attachmentItem?.externalUrl || newAttachmentItem?.link"
    [ngTemplateOutlet]="linkTemplate"
  ></ng-container>
</div>

<ng-template #fileTemplate>
  <div class="display-flex align-items-center grid-gap-16">
    <div class="display-flex align-items-center grid-gap-16 flex-1 fade-truncate attachment-item">
      <button
        type="button"
        mat-icon-button
        class="btn-attachment"
        (click)="download($event)"
        [matTooltip]="'Download file'"
        [disabled]="lockFields"
      >
        <app-icon
          [svg]="EIcon.ARROW_TO_BOTTOM"
          [iconWidth]="24"
          [iconHeight]="24"
          [iconColor]="EColorPalette.cGreen"
        ></app-icon>
      </button>
      <div
        *ngIf="showFileName"
        class="flex-1"
        [ngClass]="labelCss"
        [matTooltip]="
          attachmentItem?.originalFileName ||
          attachmentItem?.title ||
          newAttachmentItem.upload?.originalFileName ||
          newAttachmentItem.upload?.internalName ||
          ''
        "
      >
        {{
          attachmentItem?.originalFileName ||
            attachmentItem?.title ||
            newAttachmentItem.upload?.originalFileName ||
            newAttachmentItem.upload?.internalName ||
            ''
        }}
      </div>
    </div>
    <div *ngIf="showFileSize" class="display-flex align-items-center grid-gap-8 ml-auto">
      <div [ngClass]="labelCss">{{ attachmentItem?.size || newAttachmentItem.upload?.size | fileSize }}</div>
      <ng-container *ngIf="showDeleteBtn" [ngTemplateOutlet]="deleteButtonTemplate"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #linkTemplate>
  <div class="display-flex justify-content-space-between grid-gap-8">
    <div class="display-flex align-items-center grid-gap-16 flex-1 fade-truncate attachment-item">
      <button
        type="button"
        mat-icon-button
        class="btn-attachment"
        (click)="copyLink($event)"
        [matTooltip]="'Copy link'"
        [disabled]="lockFields"
      >
        <app-icon [svg]="EIcon.HYPERLINK" [iconWidth]="24" [iconHeight]="24"></app-icon>
      </button>
      <ng-container [ngTemplateOutlet]="linkValueTemplate"></ng-container>
    </div>
    <ng-container *ngIf="showDeleteBtn" [ngTemplateOutlet]="deleteButtonTemplate"></ng-container>
  </div>
</ng-template>

<ng-template #deleteButtonTemplate>
  <button
    type="button"
    class="button-icon-background btn-attachment"
    mat-icon-button
    (click)="deleteConfirmation()"
    [matTooltip]="'Remove attachment'"
    [disabled]="lockFields || lockDelete"
  >
    <app-icon [svg]="EIcon.CLOSE" [iconWidth]="22" [iconHeight]="22" [iconColor]="EColorPalette.cRed2"></app-icon>
  </button>
</ng-template>

<ng-template #linkValueTemplate>
  <div
    [ngClass]="labelCss"
    *ngIf="trimLink"
    class="body-description flex-1"
    [matTooltip]="attachmentItem?.externalUrl || newAttachmentItem?.link || ''"
  >
    <a href="{{ getLink() }}" target="_blank">{{ attachmentItem?.externalUrl || newAttachmentItem?.link || '' }}</a>
  </div>

  <div [ngClass]="labelCss" *ngIf="!trimLink" class="body-description">
    {{ attachmentItem?.externalUrl || newAttachmentItem?.link || '' }}
  </div>
</ng-template>
